import CourseSettings from "./CouseSettings";

export default CourseSettings;